module.exports = "data:text/x-markdown;base64,WW91J3ZlIHVuY292ZXJlZCBhbiBBbGllbiBjb250cmFjdC4gQ2xhaW0gb3duZXJzaGlwIHRvIGNvbXBsZXRlIHRoZSBsZXZlbC4KCiZuYnNwOwpUaGluZ3MgdGhhdCBtaWdodCBoZWxwCiogVW5kZXJzdGFuZGluZyBob3cgYXJyYXkgc3RvcmFnZSB3b3JrcwoqIFVuZGVyc3RhbmRpbmcgW0FCSSBzcGVjaWZpY2F0aW9uc10oaHR0cHM6Ly9zb2xpZGl0eS5yZWFkdGhlZG9jcy5pby9lbi92MC40LjIxL2FiaS1zcGVjLmh0bWwpCiogVXNpbmcgYSB2ZXJ5IGB1bmRlcmhhbmRlZGAgYXBwcm9hY2gK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/aliencodex.md
// module id = 1353
// module chunks = 0